/* import __COLOCATED_TEMPLATE__ from './form-controls.hbs'; */
import { service } from '@ember/service';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
export default class SiteDocumentsSharedFormControls extends Component {
  @service currentPractice;
}
